import {InjectionToken, Provider} from '@angular/core';
export let SYNC_SERVICE: any = new InjectionToken<any>('tt.loaderService');

export function syncServiceFactory(i: any): any {
	return i.get('syncService');
}

export const syncServiceProvider: Provider = {
	provide: SYNC_SERVICE,
	useFactory: syncServiceFactory,
	deps: ['$injector']
};



// WEBPACK FOOTER //
// ./src/app/shared/upgrade/sync.service.ts